import aframe from "aframe"

aframe.registerComponent('frame-depth', {
    schema: {
        enabled: {
            type: "boolean",
            default: false,
        },

        direction: {
            type: "number",
            default: 1,
        },

        velocity: {
            type: "number",
            default: 0.006,
        },

        z: {
            type: "number",
            default: -10,
        },

        y: {
            type: "number",
            default: 0, //1.6
        },

        maxZ: {
            type: "number",
            default: -28,
        },

        minZ: {
            type: "number",
            default: -3,
        }
    },

    init: function () {
        this.pEnabled = this.data.enabled // Variable that checks if previosly moved

        this.el.setAttribute("position", {
            x: 0, y: this.data.y, 
            z: this.data.z
        });
    },

    updateSchema: function (newData) {

    },

    tick: function (time, deltaTime) {
        if (this.pEnabled === true && this.data.enabled === false) this.depthEnd()
        if (!this.data.enabled) return;

        let z = this.el.getAttribute("position").z
        let newZ = z + this.data.direction * this.data.velocity * deltaTime

        if (newZ > this.data.maxZ && newZ < this.data.minZ)
            this.el.setAttribute("position", {
                x: 0, y: this.data.y,
                z: newZ,
            })

        this.pEnabled = this.data.enabled
    },

    depthEnd: function () {
        this.el.emit("depthEnd", {
            z: this.el.getAttribute("position").z
        })

        this.pEnabled = this.data.enabled
    }
})


// WEBPACK FOOTER //
// ./src/components-aframe/frameDepth.js